import axiosInstance from '@/service/helpers/axios'
export async function getTotalFollower() {
  const result = await axiosInstance.get('/follower/total-follow')
  return result
}
